module.exports = __webpack_public_path__ + "static/img/bg19.c169da3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg19.jpg
// module id = YWiX
// module chunks = 1